import { breakpoints } from 'styles';
import { Badge } from 'components/common';

const LikertAnswer = ({ answers, questions, options }) => (
  <div className="answer">
    <div className="questions">
      {questions.map((question, i) => {
        const answerIndex = answers?.find(
          (answer) => answer.id === question.id
        )?.index;

        return (
          <div className="question" key={i}>
            <div className="question-content">
              <div
                className="question-content-inner"
                dangerouslySetInnerHTML={{ __html: question.question }}
              />
            </div>
            <div className="option">
              <Badge text={`${answerIndex + 1}. ${options[answerIndex]}`} />
            </div>
          </div>
        );
      })}
    </div>

    <style jsx>{`
      .icon {
        display: inline-block;
        margin-right: 5px;
      }
      .questions {
        counter-reset: likert-questions;
      }
      .question {
        background-color: white;
        border-radius: 5px;
        padding: 10px 15px;
      }
      .question:not(:first-child) {
        margin-top: 10px;
      }
      .question-content {
        align-items: top;
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        font-size: 1.5rem;
        min-width: 0;
        position: relative;
      }
      .question-content-inner :global(p) {
        margin: 10px 0 0;
      }
      .question-content-inner :global(p:first-child) {
        margin-top: 0;
      }
      .question-content::before {
        counter-increment: likert-questions;
        content: counter(likert-questions) '.';
        display: inline-block;
        margin-right: 5px;
      }
      .option {
        margin-top: 15px;
        text-align: right;
      }
      @media (min-width: ${breakpoints.medium}px) {
        .question {
          display: flex;
        }
        .question-content {
          margin-right: 10px;
        }
        .option {
          margin-top: 0;
        }
      }
    `}</style>
  </div>
);

export default LikertAnswer;
